import { bearerAuth } from "../standardAuthPatterns";
import { defineConnector } from "../types";
import logo from "./logo.svg";

export const npm = defineConnector({
  identifier: "npm",
  name: "NPM",
  tagLine: "Package registry and publishing API",
  logo,
  protocol: "http",
  tags: ["engineering"],
  auth: (app) => bearerAuth(app.secret.accessToken),
  steps: [
    {
      title: "Create an npm access token",
      items: [
        {
          kind: "markdown",
          content:
            "In npm, create an automation or granular access token and use it as a bearer token with the registry API.",
        },
      ],
    },
    {
      title: "Enter your token",
      items: [
        {
          kind: "input",
          label: "Access token",
          required: true,
          target: { kind: "secrets", field: "accessToken" },
        },
      ],
    },
  ],
  connectionTest: {
    protocol: "http",
    request: () => "https://registry.npmjs.org/-/whoami",
  },
  defaultUrlPattern: () => "https://registry\\.npmjs\\.org/.*",
});
